import { useThemeMedia } from "../../Layout/ThemeBackground/ThemeBackground";

export default function WheelVideoRing({ rotation }) {
  const media = useThemeMedia();
  if (!media?.src) return null;

  return (
    <div
      className="wheel__tint"
      data-testid="wheel-video-tint"
      style={{ transform: `rotate(${-rotation}deg)` }}
    >
      {media.playVideo ? (
        <video
          src={media.src}
          poster={media.poster || undefined}
          autoPlay
          muted
          loop
          playsInline
          aria-hidden="true"
        />
      ) : media.poster ? (
        <img src={media.poster} alt="" />
      ) : null}
    </div>
  );
}
